import client from 'api/client';
import { AxiosResponse, AxiosRequestConfig } from 'axios';

export function sendInvitation(
    id: number,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<number>> {
    return client.get<number>(`/send-invitation/${id}`, customConfig);
}
